// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SceneThemeSwitch_wrapper__sDhbd","inner":"SceneThemeSwitch_inner__2weIG","allSize":"SceneThemeSwitch_allSize__2Nns9","icon":"SceneThemeSwitch_icon__hxKIB"};